import { AnimatedCircularProgressBar } from '@talentmesh/ui/components/animated-circular-progress-bar';
import { TypographyH4 } from '@talentmesh/ui/components/typography';
import type { PercentileLevel } from '@talentmesh/utils';

import Importance from '../../../../Components/Importance';
import UIStrings from '@/Utils/UIStrings';

interface EICharacteristicHeaderProps {
    characteristicName: string;
    percentileScore: number;
    percentileLevel: PercentileLevel;
    importanceRating: number;
}

function EICharacteristicHeader({
    characteristicName,
    percentileScore,
    percentileLevel,
    importanceRating,
}: EICharacteristicHeaderProps) {
    return (
        <>
            <div className="col-span-2 flex justify-center pb-2">
                <span className="text-muted-foreground text-xs">{UIStrings.Characteristic}</span>
            </div>
            <div className="col-span-8" />
            <div className="col-span-2">
                <span className="text-muted-foreground text-xs">{UIStrings.Importance}</span>
            </div>
            <div className="col-span-2 flex justify-center pb-2">
                <AnimatedCircularProgressBar
                    value={percentileScore}
                    level={percentileLevel}
                    className="size-12 text-lg font-semibold"
                />
            </div>
            <div className="col-span-8">
                <TypographyH4 className="text-foreground text-lg">{characteristicName}</TypographyH4>
            </div>
            <div className="col-span-2">
                <Importance weight={importanceRating} />
            </div>
        </>
    );
}

export default EICharacteristicHeader;
